// extracted by mini-css-extract-plugin
export default {"docPage":"docPage__5DB","docsWrapper":"docsWrapper_BCFX"};